module.exports = __webpack_public_path__ + "static/media/metro_logo.40ea5129.png";